import { render } from "./LocationSuggestions.vue?vue&type=template&id=51c6b1e8&scoped=true&ts=true"
import script from "./LocationSuggestions.ts?vue&type=script&lang=ts&external"
export * from "./LocationSuggestions.ts?vue&type=script&lang=ts&external"

import "./LocationSuggestions.scss?vue&type=style&index=0&id=51c6b1e8&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c6b1e8"]])

export default __exports__